const Breakpoints = (widthParameter) => {
  const width = widthParameter || window.innerWidth;
  return {
    isDesktop: width >= 1280,
    isTablet: width < 1280,
    isSmallTablet: width > 767 && width <= 960,
    isMobile: width < 768,
    isMobileSmall: width < 480,
  };
};

export default Breakpoints;
